import { css } from '@linaria/core'
import { colors } from '../theme'

export const colorCss = css`
  background: var(--button-background, transparent);
  color: var(--button-text-color);

  &:hover:not([aria-disabled='true']):not(:active) {
    background: var(--button-hover-background);
  }

  &:focus {
    background: var(--button-hover-background);
  }
  // Must be a separate selector from above or safari wont work
  &:focus-visible {
    background: var(--button-hover-background);
  }

  &:focus:not(:focus-visible) {
    // turn off the :focus selector for browsers that support :focus-visible
    background: var(--button-background, transparent);
  }

  &:active {
    background: var(
      --button-active-background
    ) !important; // So that :active doesn't get overridden by the more specific :focus selector above;
  }

  transition: background-color 0.3s;
`

export const grayLowCss = css`
  --button-text-color: ${colors.transparent.gray100};
  --button-hover-background: ${colors.transparent.gray03};
  --button-active-background: ${colors.transparent.gray05};
`

export const lowCss = css`
  --button-text-color: ${colors.color60};
  --button-hover-background: ${colors.transparent.color03};
  --button-active-background: ${colors.transparent.color05};

  &[data-white] {
    --button-text-color: ${colors.gray100};
    --button-hover-background: ${colors.transparent.gray05};
    --button-active-background: ${colors.transparent.gray10};
  }

  [high-contrast] & {
    --button-text-color: ${colors.color80};
  }
`

export const grayHighCss = css`
  --button-text-color: ${colors.gray00};
  --button-background: ${colors.gray100};
  --button-hover-background: ${colors.gray80};
  --button-active-background: ${colors.gray90};
  &[data-white] {
    --button-text-color: ${colors.gray100};
    --button-background: #000;
    --button-hover-background: #1d1d1d;
    --button-active-background: #000;
  }
`

export const highCss = css`
  --button-text-color: ${colors.gray00};
  --button-background: ${colors.color60};
  --button-hover-background: ${colors.color50};
  --button-active-background: ${colors.color70};
  &[data-white] {
    --button-text-color: ${colors.gray100};
  }
`

export const lightHighCss = css`
  --button-text-color: ${colors.color90};
  --button-background: ${colors.color05};
  --button-hover-background: ${colors.color03};
  --button-active-background: ${colors.color10};

  /*
   * This creates a completely white button, with colored text. It is meant to look starkly different
   * from how a lightHigh button looks outside of a whiteTheme component
   */
  &[data-white] {
    --button-text-color: ${colors.color60};
    --button-background: ${colors.gray100};
    --button-hover-background: ${colors.gray100};
    --button-active-background: ${colors.gray90};
  }
`

export const grayLightHighCss = css`
  --button-text-color: ${colors.gray100};
  --button-background: ${colors.gray02};
  --button-hover-background: ${colors.gray00};
  --button-active-background: ${colors.gray03};

  &[data-white] {
    --button-text-color: #000;
    --button-background: ${colors.gray100};
    --button-hover-background: ${colors.gray100};
    --button-active-background: ${colors.gray90};
  }
`

export const highNightCss = css`
  --button-text-color: ${colors.gray100};
  --button-background: ${colors.color30};
  --button-hover-background: ${colors.color40};
  --button-active-background: ${colors.color20};
`
export const grayHighNightCss = css`
  --button-text-color: ${colors.gray00};
  --button-background: ${colors.gray90};
  --button-hover-background: ${colors.gray100};
  --button-active-background: ${colors.gray80};
`
export const lightHighNightCss = css`
  --button-text-color: ${colors.color90};
  --button-background: ${colors.color05};
  --button-hover-background: ${colors.color20};
  --button-active-background: ${colors.color03};
`
export const grayLightHighNightCss = css`
  --button-text-color: ${colors.gray100};
  --button-background: ${colors.gray05};
  --button-hover-background: ${colors.gray10};
  --button-active-background: ${colors.gray03};
`
